/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {TableHeaderEntryModel} from '../../../shared/table/models/table-header-entry.model';
import {SettlementAgreementColumnEnum} from './models/settlement-agreement-column.enum';
import * as SettlementsMainPageDataPipes
    from './../../settlements-main-page/data-pipes/settlement-main-page-data-pipes';

const settlementAgreementTableHeaders: {
    quantity: TableHeaderEntryModel<SettlementAgreementColumnEnum>;
    materialsUnitNetPrice: TableHeaderEntryModel<SettlementAgreementColumnEnum>;
    materialsTotalNetCost: TableHeaderEntryModel<SettlementAgreementColumnEnum>;
    taxRate: TableHeaderEntryModel<SettlementAgreementColumnEnum>;
    materialsTotalGrossCost: TableHeaderEntryModel<SettlementAgreementColumnEnum>;
    teMinutesAmount: TableHeaderEntryModel<SettlementAgreementColumnEnum>;
    teMinutesUnitCost: TableHeaderEntryModel<SettlementAgreementColumnEnum>;
    teMinutesAdditionalCosts: TableHeaderEntryModel<SettlementAgreementColumnEnum>;
    teMinutesTotalCost: TableHeaderEntryModel<SettlementAgreementColumnEnum>;
    blueFapiaoNumber: TableHeaderEntryModel<SettlementAgreementColumnEnum>;
    deliveryNumber: TableHeaderEntryModel<SettlementAgreementColumnEnum>;
    comments: TableHeaderEntryModel<SettlementAgreementColumnEnum>;
} = {
    quantity: {
        code: SettlementAgreementColumnEnum.QUANTITY,
        name: 'Quantity',
        sortable: false,
        widthWeight: 4,
        hasTextAlignRight: true
    },
    materialsUnitNetPrice: {
        code: SettlementAgreementColumnEnum.MATERIALS_UNIT_NET_PRICE,
        name: 'Net price',
        sortable: false,
        widthWeight: 4,
        hasTextAlignRight: true,
        dataPipe: SettlementsMainPageDataPipes.financialNumberPipe
    },
    materialsTotalNetCost: {
        code: SettlementAgreementColumnEnum.MATERIALS_TOTAL_NET_COST,
        name: 'Total net price',
        sortable: false,
        widthWeight: 5,
        hasTextAlignRight: true,
        dataPipe: SettlementsMainPageDataPipes.financialNumberPipe
    },
    taxRate: {
        code: SettlementAgreementColumnEnum.TAX_RATE,
        name: 'Tax rate',
        sortable: false,
        widthWeight: 4,
        hasTextAlignRight: true,
        dataPipe: SettlementsMainPageDataPipes.percentPipe
    },
    materialsTotalGrossCost: {
        code: SettlementAgreementColumnEnum.MATERIALS_TOTAL_GROSS_COST,
        name: 'Total amount',
        sortable: false,
        widthWeight: 5,
        hasTextAlignRight: true,
        dataPipe: SettlementsMainPageDataPipes.financialNumberPipe
    },
    teMinutesAmount: {
        code: SettlementAgreementColumnEnum.TE_AMOUNT,
        name: 'Quantity',
        sortable: false,
        hasTextAlignRight: true,
        widthWeight: 4
    },
    teMinutesUnitCost: {
        code: SettlementAgreementColumnEnum.TE_UNIT_COST,
        name: 'Price per minute',
        sortable: false,
        widthWeight: 6,
        hasTextAlignRight: true,
        dataPipe: SettlementsMainPageDataPipes.financialNumberPipe
    },
    teMinutesAdditionalCosts: {
        code: SettlementAgreementColumnEnum.TE_ADDITIONAL_COSTS,
        name: 'Additional costs',
        sortable: false,
        widthWeight: 6,
        hasTextAlignRight: true,
        dataPipe: SettlementsMainPageDataPipes.financialNumberPipe
    },
    teMinutesTotalCost: {
        code: SettlementAgreementColumnEnum.TE_TOTAL_COST,
        name: 'Total amount',
        sortable: false,
        widthWeight: 6,
        hasTextAlignRight: true,
        dataPipe: SettlementsMainPageDataPipes.financialNumberPipe
    },
    blueFapiaoNumber: {
        code: SettlementAgreementColumnEnum.BLUE_FAPIAO_NUMBER,
        name: 'Blue fapiao',
        sortable: false,
        widthWeight: 8
    },
    deliveryNumber: {
        code: SettlementAgreementColumnEnum.DELIVERY_NUMBER,
        name: 'Delivery note',
        sortable: false,
        widthWeight: 7
    },
    comments: {
        code: SettlementAgreementColumnEnum.COMMENTS,
        name: 'Comments',
        sortable: false,
        widthWeight: 7,
        hasTextAlignRight: true,
        hasFloatContent: true
    }
};

export default settlementAgreementTableHeaders;
